<script>
 import { customerMethods, customerListComputed, layoutMethods, exportMethods,erpFixMessages } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
 import Swal from "sweetalert2";

/**
 * Business information component
 */
export default {
  page: {
    title: "Business information"
  },
  data() {
    return {
      title: "Business information",
      dataList: [],      
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        {
          key: "business_name",
          sortable: true,
        },

        {
          key: "name",
          sortable: true,
        },

        {
          key: "contact_info",
          sortable: true,
        },
        {
          key: "business_type",
          sortable: true,
        },
        {
          key: "wallet_status",
          sortable: true,
        },
        {
          key: "registered",
          sortable: true,
        },

      ],
      view: {
        name: '',
        businessName: '',
        number: '',
        email: '',
        address: '',

      },
      coinvalue: "",
      statusValue: "",
      typeValue: null,
      datepickervalue: "",
      showModal: false,
      submitted: false,

      selected: null,
      options: [
        { value: 'A', text: 'TM (from options prop)' },
        { value: 'B', text: 'Globe (from options prop)' }
      ],
      searchValue: {
        search: null,
        searchField: null,
        addressRegion: null,
        addressRegionField: 'b.region',
        addressProvince: null,
        addressProvinceField: 'b.province',
        addressCity: null,
        addressCityField: 'b.city',
        addressBarangay: null,
        addressBarangayField: 'b.barangay',
        businessType: null,
        businessTypeField: 'b.sub_type',
        dateRange: null,
        walletStatus: null
      },
      sortingValue:{
        sort : "",
        orderDesc : "",
      },
      searchList: [
        { text: 'Select to search', value: null },
        { text: 'Name', value: 'u.name' },
        { text: 'Business Name', value: 'b.name' },
        { text: 'Business Type', value: 'b.sub_type' },
        { text: 'Mobile Number', value: 'u.mobile_number' },
        { text: 'Email', value: 'u.email' },
      ],
      rangeOptions: {
        mode: "range",
      },
      dateRangeError: false,
      actionIndex: -1,
      searching: false,
      can_export: true,

      provinceDisable: true,
      cityDisable: true,
      barangayDisable: true,
      walletStatusOptions: [
        { text: 'All', value: null },
        { text: 'Enabled', value: 0 },
        { text: 'Freezed', value: 1 },
      ]
    };
  },
  components: {
    flatPickr
  },
  computed: {
    ...customerListComputed,
    ...erpFixMessages,
  },
  mounted() {
    this.getBusinessList({
      page: this.currentPage
    })

    this.changeTitle({title: 'Business List'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Business List', to: { name: 'Business'} }
      ]
    });
    this.getBussList();
    
    this.getBusinessTypesList();
    this.getRegions();
  },
  methods: {
    ...layoutMethods,
    ...customerMethods,
    ...exportMethods,
    async getRegions() {
      this.provinceDisable = true;
      this.cityDisable = true;
      this.barangayDisable = true;
      await this.getRegionList();
      this.searchValue.addressProvince = null;
      this.searchValue.addressCity = null;
      this.searchValue.addressBarangay = null;
      this.provinceDisable = this.searchValue.addressRegion != null ? false : true;
    },
    async getProvinces() {
      this.searchValue.addressProvince = null
      this.searchValue.addressCity = null;
      this.searchValue.addressBarangay = null;
      this.cityDisable = true;
      this.barangayDisable = true;
      if(this.searchValue.addressRegion != null){
        await this.getProvinceList(this.searchValue.addressRegion);
      }
      this.provinceDisable = this.searchValue.addressRegion != null ? false : true;
    },
    async getCities() {
      this.searchValue.addressCity = null
      this.searchValue.addressBarangay= null
      this.barangayDisable = true;
      if(this.searchValue.addressProvince != null){
        await this.getCityList(this.searchValue.addressProvince);
      }
      this.cityDisable = this.searchValue.addressProvince != null ? false : true;
    },
    async getBrgys() {
      this.searchValue.addressBarangay= null
      if(this.searchValue.addressCity != null){
        await this.getBarangayList(this.searchValue.addressCity);
      }
      this.barangayDisable = this.searchValue.addressCity != null ? false : true;
    },
    async onExport(){
      // await this.onSearch();
      if(!this.can_export){
        this.$alertify.error("Please select an item in the list.");
        this.can_export = true;
        return;
      }
      if(this.businessListTotal ==0){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      let params = {
          module: 'business_info',
          keyword: this.searchValue.search,
          field: this.searchValue.searchField,
          email: JSON.parse(localStorage.getItem('userData')).email,
          walletStatus: this.searchValue.walletStatus
      };

      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    async getBussList() {
      await this.getBusinessList({
        page: this.currentPage,
        ...this.sortingValue
     })
    },
    async searchBusiness() {
      await this.getBusinessList({
        page: this.currentPage,
        rows: this.perPage,
        ...this.searchValue
      })
    },
    async onPageUpdate(reset = "") {
      if(this.searchValue.dateRange != null || this.searchValue.walletStatus != null){
        if(reset == "reset"){
          this.currentPage = 1
        }
        this.dateRangeError = false;
        await this.searchBusiness()
      } else {
        this.dateRangeError = true;
        // await this.getBussList()
      }
    },
    async onSearch() {
      // if(this.searchValue.search.length > 0 && this.searchValue.searchField == null){
      //   this.can_export = false
      //   return;
      // }
      this.currentPage = 1
      if (this.searchValue.search) {
        this.searching = true
        await this.searchBusiness()
      } else {
        this.searching = false
        this.searchValue = {
          search: null,
          searchField: null,
        }
        await this.getBussList()
      }
    },
    tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'business_name' :
                column = 'b.name';
                break;
            case 'name' :
                column = 'u.name';
                break;
            case 'contact_info' :
                column = 'b.mobile_number';
                break;
            case 'business_type' :
                column = 'b.sub_type';
                break;
            case 'registered' :
                column = 'b.created_at';
                break;
            case 'wallet_status' :
                column = 'b.account_freeze';
                break;
        }
        
        this.sortingValue.sort = column;
        this.sortingValue.orderDesc = action.sortDesc;
        console.log(this.sortingValue);   
        this.getBusinessList({
          page: this.currentPage,
          ...this.sortingValue,
          ...this.searchValue
        })     
    },
    refresh(){
       this.getBusinessList({
        page: this.currentPage,
      })
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  }, 

};
</script>

<style scoped>
 .customer-name {
   color:#804997;
 }
</style>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{businessListTotal}}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <div class="col-md-6" style="text-align: right;">
     
                <b-button variant="primary"  type="button" @click="onExport" class="btn btn-primary h-fit me-2">
                  <i class='bx bx-export bx-fw me-1'></i>Export
                </b-button>
                <button class="btn btn-secondary" @click="refresh()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <!-- end col -->

              
              <!-- Search and button -->
              <div class="d-flex flex-wrap mt-3 mb-2 px-3">           
                <div class="me-2 ta-right">
                  <b-form-group id="input-group-3" label-for="input-3" description="Search Keyword">     
                    <form class="d-flex" @submit.prevent="onSearch()">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchList"
                      ></b-form-select>

                      <b-input-group description=" ">
                        <b-form-input v-model="searchValue.search" class="rounded-0 rounded-end " v-on:keydown.enter="onPageUpdate('reset')"></b-form-input>
                        <b-input-group-append v-if="false">
                          <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                            <i class='bx bx-search bx-fw'></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </b-form-group>
                </div>

                <div class="me-2 ta-right">
                  <b-form-group id="input-group-3" label-for="input-3" description="Filter by Business Type">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:250px"
                      id="input1"
                      v-model="searchValue.businessType"
                      :options="businessTypesList"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>          

                <div class="me-2 ta-right">
                 <b-form-group label-for="wallet-status" description="Filter by Wallet Status">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="wallet-status"
                      v-model="searchValue.walletStatus"
                      :options="walletStatusOptions"
                    ></b-form-select>
                  </b-form-group>
                </div>

                <!-- <div class="me-2">
                  <b-form-group id="input-group-3" label-for="input-3" description="Filter by Address">
                    <form class="d-flex" @submit.prevent="onSearch()">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                          id="input-2"
                          v-model="searchValue.addressField"
                          :options="businessTypesList"
                          required
                        ></b-form-select>

                      <b-input-group description=" ">
                        <b-form-input v-model="searchValue.address" class="rounded-0 rounded-end " style="width:190px"></b-form-input>
                        <b-input-group-append v-if="false">
                          <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                            <i class='bx bx-search bx-fw'></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </b-form-group>
                </div> -->

                <div class="me-2 ta-right">
                  <validation-provider
                    rules="required"
                  >
                    <b-form-group description="Filter by Date">
                      <flat-pickr
                        v-model="searchValue.dateRange"
                        :config="rangeOptions"
                        placeholder="Select a date range"
                        class="form-control"
                        v-bind:class="{'is-invalid' : dateRangeError}"
                        style="width: 220px"
                      ></flat-pickr>
                      <b-form-invalid-feedback>Please select date range</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </div>                   
              </div>

              <div class="d-flex flex-wrap mt-1 mb-3 px-3">

                <div class="me-2 ta-right">
                  <b-form-group label-for="input1" description="Filter by Region">
                    <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:220px"
                      id="input1"
                      v-model="searchValue.addressRegion"
                      :options="regionList"
                      v-on:change="getProvinces"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>        
                
                <div class="me-2 ta-right">
                  <b-form-group label-for="input2" description="Filter by Province">
                    <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:220px"
                      id="input2"
                      v-model="searchValue.addressProvince"
                      :options="provinceList"
                      v-on:change="getCities"
                      :disabled="provinceDisable"
                      required
                    >
                    </b-form-select>
                  </b-form-group>
                </div>    
                
                <div class="me-2 ta-right">
                  <b-form-group id="input-group-3" label-for="input-3" description="Filter by City/Municipality">
                    <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:180px"
                      id="input3"
                      v-model="searchValue.addressCity"
                      :options="cityList"
                      v-on:change="getBrgys"
                      :disabled="cityDisable"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>    
                
                <div class="me-2 ta-right">
                  <b-form-group id="input-group-3" label-for="input-3" description="Filter by Barangay">
                    <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:185px"
                      id="input4"
                      v-model="searchValue.addressBarangay"
                      :options="barangayList"
                      :disabled="barangayDisable"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>    

              <!-- </div>
              <div class="d-flex flex-wrap mt-1 mb-3 px-3"> -->

                <div class="me-2">
                  <a class="btn btn-primary h-fit" type="submit"  @click="onPageUpdate('reset')">
                    <i class='bx bx-search bx-fw me-1'></i>Search
                  </a>
                </div>           
              </div>
            </div>
              <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="businessList"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  @sort-changed="tableSorting"
                  class="table-check"
                >

                  <template #cell(business_name)="data">
                    <span class="text-body m-0"><router-link :to="{ name: 'Business Detail', params: { id: data.item.businessId }}" class="customer-name">{{ data.item.businessName }}</router-link></span>
                  </template>

                  <template #cell(name)="data">
                    <span class="text-body m-0"><router-link :to="{ name: 'Subscriber Detail', params: { id: data.item.subscriberId }}">{{ data.item.subscriberName }}</router-link></span>
                  </template>

                  <template #cell(contact_info)="data">
                    <p class="text-body m-0">{{ data.item.businessMobileNumber }} - {{ data.item.businessEmail }}</p>
                  </template>

                  <template #cell(business_type)="data">
                    <p class="text-body m-0">{{ data.item.businessSubType }}</p>
                  </template>

                  <template #cell(wallet_status)="data">
                    <p class="text-success m-0" v-if="data.item.account_freeze == 0"> Enabled </p>
                    <p class="text-danger m-0" v-else-if="data.item.account_freeze == 1"> Freezed </p>
                  </template>

                  <template #cell(registered)="data">
                    <p class="text-body m-0">{{ data.item.registered | formatDate}}</p>
                  </template>

                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="businessListTotal == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="businessListTotal != 0 && businessListTotal > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <!-- pagination -->
                       <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="businessListTotal"
                        :per-page="perPage"
                        @input="onPageUpdate"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
